import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const MinusIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Collapse</title>
    <rect y="17.14" width="48" height="13.71" />
  </IconBase>
);
